export default {"src":"/_next/static/media/carUncircled_24.9a64c3f3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};